module.exports = __webpack_public_path__ + "img/10.50fc88d7.png";